import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

// Maps URL segments to human-readable labels
const ROUTE_LABELS = {
  'clothing':               'Clothing',
  'accessories':            'Accessories',
  'printed-materials':      'Printed Materials',
  'promotional-materials':  'Promotional Materials',
  'packaging-display':      'Packaging & Display',
  'full-sublimation':       'Full Sublimation',
  'promotions':             'Promotions',
  'collections':            'Collections',
  'all-products':           'All Products',
  'cart':                   'Cart',
  'order-review':           'Order Review',
  'pending-approval':       'Pending Approval',
  'checkout':               'Check Out',
  'account':                'Account',
  'personal-information':   'Personal Information',
  'saved-address':          'Saved Address',
  'purchase-history':       'Purchase History',
  'email-notifications':    'Email Notifications',
  // Product subcategories
  't-shirt':    'T-Shirt',
  'jersey':     'Jersey',
  'polo-shirt': 'Polo Shirt',
  'longsleeve': 'Longsleeve',
  'uniforms':   'Uniforms',
};

// Given a raw URL segment, return a display label
function getLabel(segment) {
  const lower = segment.toLowerCase();
  if (ROUTE_LABELS[lower]) return ROUTE_LABELS[lower];
  // Fallback: capitalize each word, replace hyphens with spaces
  return segment
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export default function Breadcrumb() {
  const { pathname, state } = useLocation();

  // ── Custom crumbs override ───────────────────────────────────────────────
  // Any page can pass { breadcrumbTrail: [{ label, path }, ...] } via
  // navigate('/some-path', { state: { breadcrumbTrail: [...] } })
  // to show a custom trail that doesn't match the URL structure.
  // Example from Cart → OrderReview:
  //   navigate('/order-review', { state: {
  //     breadcrumbTrail: [
  //       { label: 'Home',         path: '/'            },
  //       { label: 'Cart',         path: '/cart'        },
  //       { label: 'Order Review', path: '/order-review'},
  //     ],
  //     selectedCartItems: [...],
  //   }})
  const customTrail = state?.breadcrumbTrail;

  // Split path into segments, filter out empty strings
  const segments = pathname.split('/').filter(Boolean);

  // Don't render on the homepage
  if (segments.length === 0) return null;

  // Use custom trail if provided, otherwise build from URL
  const crumbs = customTrail && customTrail.length > 0
    ? customTrail
    : [
        { label: 'Home', path: '/' },
        ...segments
          .filter(seg => seg !== 'account')
          .map((seg, i, filtered) => ({
            label: getLabel(seg),
            path: '/' + segments.slice(0, segments.indexOf(seg) + 1).join('/'),
          })),
      ];

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={crumb.path} className="breadcrumb-item">
              {isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {crumb.label}
                </span>
              ) : (
                <>
                  <Link to={crumb.path} className="breadcrumb-link">
                    {crumb.label}
                  </Link>
                  <span className="breadcrumb-separator" aria-hidden="true">›</span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}